define('collection/WorkingDayCollection',['require','lib/collection/BaseCollection','model/DayModel','Config'],function (require) {
	
	var BaseCollection = require('lib/collection/BaseCollection');
	var DayModel = require('model/DayModel');

	var Config = require('Config');
	
	/**
	 * Working days list collection
	 * 
	 * @class WorkingDayCollection
	 */
	return BaseCollection.extend({
		
		url: '/booking/working-days/',
		model: DayModel,

		getDays: function (diff) {
			var result = [];
			this.each(function (day) {
				var dayOff = day.get('is_day_off');
				if (diff != 0) {
					dayOff = this._isDayOff(Date.parseMysqlDate(day.get('date')), diff);
				}
				var workDay = {
					date: day.get('date'),
					id: day.get('id'),
					is_day_off: dayOff
				};

				result.push(workDay);
			}, this);

			return result;
		},

		_isDayOff: function (date, diff) {
			var mysqlDate = date.getMysqlDate();
			for (var i = 0; i < this.length; i++) {
				var day = this.at(i);
				if (day.get('time').length === 0 || day.get('is_day_off')) {
					continue;
				}
				var time = day.get('time')[0];

				var dateFrom = new Date(Date.parseMysqlDate(day.get('date') + ' ' + time.from).getTime() + diff * 60000);
				var dateTo = new Date(Date.parseMysqlDate(day.get('date') + ' ' + time.to).getTime() + (diff * 60000) - 1000); // -1 to skip 00:00

				if (dateFrom.getMysqlDate() === mysqlDate || dateTo.getMysqlDate() === mysqlDate) {
					return false;
				}
			}
			return true;
		},

		isDayOff : function (date, diff){
			date = Date.parseMysqlDate(date);
			return this._isDayOff(date, diff?diff:0);
		},

		isWlAvailable : function (date, diff){
			date = Date.parseMysqlDate(date);
			var mysqlDate = date.getMysqlDate();

			for (var i = 0; i < this.length; i++) {
				var day = this.at(i);

				if(day.get('date') === mysqlDate){
					return day.get('is_wl_available');
				}
			}
			return false;
		}

	});
	
});
